<template lang="pug">
div.coupons-management-page
  coupon-management
</template>

<script>
import CouponManagement from '@/components/admin/CouponManagement.vue'

export default {
  name: 'CouponsManagement',
  
  components: {
    CouponManagement
  },
  
  metaInfo() {
    return {
      title: 'Gestión de Cupones de Descuento'
    }
  }
}
</script>

<style scoped>
.coupons-management-page {
  width: 100%;
  height: 100%;
}
</style>
